const initialState = {
  loading: false,
  data: null,
  error: null,
};

const professionalTournamentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PROFESSIONAL_TOURNAMENT_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_PROFESSIONAL_TOURNAMENT_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_PROFESSIONAL_TOURNAMENT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default professionalTournamentReducer;
